 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		52: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		52: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyAssignments~MyC~3abcad88","2":"AssignmentsModalV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~TakeAssessmentModal","3":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","6":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","7":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","8":"Checkout~Gift","9":"LandingPage~Pricing","10":"RegistrationModal~SwitchAccountModal","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"DirectShareWorksheets","20":"FeaturedArtwork","21":"FillableWorksheet","22":"Gift","23":"GoalDetails","24":"GradeFilteredContentCards","25":"GradeWorksheetModal","26":"HomeLearning","27":"InteractiveWorksheetsOverview","28":"KidFrame","29":"KidFrameDetail","30":"LandingPage","31":"MemberHomepage","32":"MyAssignments","33":"MyCollections","34":"MyStudents","35":"Onboarding","36":"PracticeSkill","37":"PredefinedCollectionsDetail","38":"Pricing","39":"ProgressTracker","40":"RegistrationModal","41":"RelatedGuidedLesson","42":"Reviews","43":"SeasonalDaysDropdown","44":"Sellpage","45":"SubPlansList","46":"SwitchAccountModal","47":"TakeAssessmentModal","48":"vendors~Gift","49":"vendors~MemberHomepage","50":"vendors~MyStudents","51":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"67a24988668f9fc64b73","1":"6019e19eaf37aeb7a1cc","2":"ebf9fd967f105e578f90","3":"804101049d55fab779b0","4":"ce2d5003233b74849d4c","5":"5d84e039113e34e4ddcf","6":"82cfe861ba913fe17e6f","7":"72b494385369ac19b0ef","8":"21eaa19fde44614d00d9","9":"aedbbd8ee97baf1b0853","10":"e09d7c4a225fa454d681","11":"2ec020648721af56f263","12":"1ccb0fc1bbccf92490b3","13":"ab7403a209463e9f64a8","14":"9f27797ac54a68317db5","15":"46cf39cb0f5d5a1f521d","16":"4c8cfbb89eaec2e6bf13","17":"90cbe624b95e29e0b92a","18":"4bd5f7cdeb7c7e064c7f","19":"05b70e1b263788e30595","20":"62fff661648a707778f0","21":"ad06e1f017638504ca69","22":"9b0a3f60d0a72969c96c","23":"9dcabf5c6c52c3cca797","24":"d6c6bf8c3e1d9a158d99","25":"3550bc9c5db519176a90","26":"21ce64dacf6bdb7faddd","27":"1207f34a854d45559dc0","28":"6a2f4560fbec06c4e99f","29":"4a362ce49e702d4cf89c","30":"facb8f580aa572e3cbc5","31":"4328940f3656afb5e443","32":"704395fb957238a37e8c","33":"c72ca5772823fb6839e5","34":"dd43be9bc344097b7f49","35":"3a7c9df39f8f99a84711","36":"9800ad09afe7b4c8df20","37":"05058b7639245e53433f","38":"5ecb4ca49cd25c963050","39":"30bcdc3921a548a2791a","40":"08fa3774180b80631643","41":"a702f13adb9e8224be22","42":"f168b2bb85dca44fd7cf","43":"4cab5416c18bcb738fd0","44":"48faa5a18043bb2f7980","45":"862068df8c9dda2220af","46":"687f4c0934267f1611b9","47":"198135fdfa1fc0b794bd","48":"9fd301228a097f07cb06","49":"e0c19def07e9e60843fc","50":"56a3e4e57c3b040a68d7","51":"221f8599c655e2f94bdc","54":"c439736a54727ada7eeb","55":"bed5ac3b478b1d43ee4f","56":"5936b2096dc810404221"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"8":1,"9":1,"10":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"38":1,"39":1,"42":1,"43":1,"44":1,"47":1,"48":1,"54":1,"55":1,"56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyAssignments~MyC~3abcad88","2":"AssignmentsModalV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~TakeAssessmentModal","3":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","6":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","7":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","8":"Checkout~Gift","9":"LandingPage~Pricing","10":"RegistrationModal~SwitchAccountModal","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"DirectShareWorksheets","20":"FeaturedArtwork","21":"FillableWorksheet","22":"Gift","23":"GoalDetails","24":"GradeFilteredContentCards","25":"GradeWorksheetModal","26":"HomeLearning","27":"InteractiveWorksheetsOverview","28":"KidFrame","29":"KidFrameDetail","30":"LandingPage","31":"MemberHomepage","32":"MyAssignments","33":"MyCollections","34":"MyStudents","35":"Onboarding","36":"PracticeSkill","37":"PredefinedCollectionsDetail","38":"Pricing","39":"ProgressTracker","40":"RegistrationModal","41":"RelatedGuidedLesson","42":"Reviews","43":"SeasonalDaysDropdown","44":"Sellpage","45":"SubPlansList","46":"SwitchAccountModal","47":"TakeAssessmentModal","48":"vendors~Gift","49":"vendors~MemberHomepage","50":"vendors~MyStudents","51":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"21c26712ad69a7171d89","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"dff7ff826b2c488d7287","9":"2b436e69b3b155a4a770","10":"45ea3a3893042d5019ec","11":"31d6cfe0d16ae931b73c","12":"4ad35bb3dca41c2cae0b","13":"15a87284e63da5cf4e77","14":"13a4e7436120b3088257","15":"6372d3af599f01aafbe5","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"2087248043751533f11c","19":"0302bbe2049c9dd34e07","20":"d56d9288e4c0c7368f48","21":"31d6cfe0d16ae931b73c","22":"1b02f180c676ddd743cd","23":"70874abc2be77d282a23","24":"0ccdbb0bed9d9a533985","25":"78f108ef2a1e16d4d1b4","26":"4c89bea8f7f35505c32a","27":"8d1356e1827dc4463b48","28":"a54b9b39138a43e0632e","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"cb094bc9a01552555e08","32":"658b848aed58ee2c7a26","33":"0f2605ecd66c7b5a81b2","34":"94f0c6ba1979bda27d9d","35":"3e3946facd93a178be00","36":"5491656ee574e8b4a49d","37":"31d6cfe0d16ae931b73c","38":"cc6b5ccd34bf09b0f268","39":"85451f8c42dae0de4f7f","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"ba9c0fc38afc58c1902d","43":"495c0b9853cb793a31ee","44":"fed495f6ff9f57243990","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"bf40f2159a5c06b0446f","48":"ca68f8fa1dd9edae64fc","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","54":"73757343e8948e9de57a","55":"c7c112df630d782cdeed","56":"c7c112df630d782cdeed"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([398,53]);
 	// run deferred modules when ready
 	return checkDeferredModules();
